import { createContext, useContext } from "react";

export interface CompanyFormContextValue {
  fieldRequiredErrorMessage: string;
  fieldInvalidFormatErrorMessage: string;
}

export const CompanyFormContext = createContext<
  CompanyFormContextValue | undefined
>(undefined);

export const useCompanyFormContext = () => {
  const context = useContext(CompanyFormContext);
  if (context === undefined) {
    throw new Error(
      "useCompanyFormContext must be used within a CompanyForm component"
    );
  }

  return context;
};
